import type { HTMLChakraProps } from '@chakra-ui/react-v2';
import { forwardRef, useMergeRefs } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { useConversationContext } from '../ConversationContext';
import { useConversationStyles } from '../useConversationStyles';

export type ConversationContentProps = HTMLChakraProps<'div'>;

/**
 * Content region for the Conversation - this is the scrollable container.
 * The scrollRef is attached here, and contentRef is attached to an inner wrapper.
 */
export const ConversationContent: React.FC<ConversationContentProps> =
  forwardRef<ConversationContentProps, 'div'>(({ children, ...props }, ref) => {
    const { content } = useConversationStyles();
    const { scrollRef, contentRef } = useConversationContext();
    const mergedScrollRef = useMergeRefs(ref, scrollRef);

    return (
      <chakra.div
        ref={mergedScrollRef}
        sx={content}
        className="conversation-content"
        {...props}
      >
        <chakra.div ref={contentRef}>{children}</chakra.div>
      </chakra.div>
    );
  });
ConversationContent.displayName = 'ConversationContent';
